import React, { useEffect, useState } from "react";
import Store from "./store";
import OrganizationRequest from "../../../actions/organization";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import CompanyDetail from "./companyDetail";
import Layout from "../../../components/layout/Layout";
import Admin from "../../../components/auth/Admin";
import { isAuth } from "../../../actions/auth";
import Permission from "../../../components/auth/Permisstion";
export default function CompanySetting() {
  const [data, setData] = useState(null);
  const { NotifyMessage, notify, setNotify } = Notify();

  const { viewAllOrganization } = OrganizationRequest();
  useEffect(() => {
    if (isAuth()) {
      getAdminData()
    }
  }, []);
  const getAdminData = () => {
    viewAllOrganization(isAuth()?.staffOrganizations[0]?.organization?.id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.organization) {
        setData(data.organization);
      }
    });
  };
  return (
    <Layout>
      <Permission permission="generalSetting"/>
      <Admin>
        <CompanyDetail getAdminData={getAdminData}company={data} />
        <Store />
        <Notification notify={notify} setNotify={setNotify} />
      </Admin>
    </Layout>
  );
}
